import { render, staticRenderFns } from "./BaseFab.vue?vue&type=template&id=3f07f658&scoped=true&"
import script from "./BaseFab.vue?vue&type=script&lang=js&"
export * from "./BaseFab.vue?vue&type=script&lang=js&"
import style0 from "./BaseFab.vue?vue&type=style&index=0&id=3f07f658&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f07f658",
  null
  
)

export default component.exports